var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-main',[_c('v-container',{attrs:{"fluid":""}},[_c('v-row',{attrs:{"cols":"12"}},[_c('v-col',{attrs:{"cols":"12"}},[_c('tableFaqAccommodation',{ref:"tableFaqAccommodation"})],1)],1)],1),_c('navbar',{attrs:{"title":"ARES - OpenAI","type":"openai","home":true},on:{"actionClick":_vm.actionClick}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }